import Image from "next/future/image";

import Link from "next/link";
import { useRouter } from "next/router";
const BlogItem = ({ blog }) => {
  const { id, title, image, category, createdAt, count } = blog;
  const { locale } = useRouter();
  return (
    <>
      <div className="blog-item">
        <div className="b-img">
          <Image
            src={`${process.env.NEXT_PUBLIC_MAIN_URL}${image}`}
            width={390}
            height={292}
            alt=""
            loading="lazy"
          />
          <Link href={`/blog/${id}`}>
            <a aria-label="blogs"></a>
          </Link>
        </div>
        <div className="b-data">
          <span>{category?.title?.[locale] ?? count}</span>
          <h4>
            <Link href={`/blog/${id}`}>
              <a aria-label="blogs">{title?.[locale]}</a>
            </Link>
          </h4>
          <p>
            <span>{new Date(createdAt).toDateString()}</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default BlogItem;
